export default {
  title: 'Konfiguracja realizacji pakietów',
  form: {
    title: 'Utwórz realizację',
    companies: {
      label: 'Firmy',
    },
  },
  table: {
    title: 'Historia realizacji',
    fields: {
      name: 'Firma',
      fulfilled: 'Zrealizowano o',
    },
  },
  buttons: {
    create_fulfillment: 'Utwórz realizację',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_create_fulfillment: 'Nie udało się utworzyć realizacji',
  },
};
